// source: projects/erp/service/api/v1/model/chines_order.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var projects_erp_service_api_v1_model_money_pb = require('../money_pb.js');
goog.object.extend(proto, projects_erp_service_api_v1_model_money_pb);
goog.exportSymbol('proto.mycargo.projects.erp.api.v1.model.ChinesOrder', null, global);
goog.exportSymbol('proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mycargo.projects.erp.api.v1.model.ChinesOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mycargo.projects.erp.api.v1.model.ChinesOrder.displayName = 'proto.mycargo.projects.erp.api.v1.model.ChinesOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.displayName = 'proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.mycargo.projects.erp.api.v1.model.ChinesOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    customerName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    category: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    clientName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    vin: jspb.Message.getFieldWithDefault(msg, 8, ""),
    shipmentStatus: jspb.Message.getFieldWithDefault(msg, 9, ""),
    purchasedAt: (f = msg.getPurchasedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    amountStatus: jspb.Message.getFieldWithDefault(msg, 11, ""),
    vehicleAmount: (f = msg.getVehicleAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    shipmentAmount: (f = msg.getShipmentAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    totalAmount: (f = msg.getTotalAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    paidAmount: (f = msg.getPaidAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    pendingAmount: (f = msg.getPendingAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    revertedAmount: (f = msg.getRevertedAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    debtedAmount: (f = msg.getDebtedAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    toBePaidAmount: (f = msg.getToBePaidAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 20, ""),
    comment: jspb.Message.getFieldWithDefault(msg, 21, ""),
    isArchive: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    storageFeeAmount: (f = msg.getStorageFeeAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    storageFeeAmount2: (f = msg.getStorageFeeAmount2()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    storageFeeAmount3: (f = msg.getStorageFeeAmount3()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    storageFeeAmount4: (f = msg.getStorageFeeAmount4()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    storageFeeAmount5: (f = msg.getStorageFeeAmount5()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    totalStorageFeeAmount: (f = msg.getTotalStorageFeeAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mycargo.projects.erp.api.v1.model.ChinesOrder;
  return proto.mycargo.projects.erp.api.v1.model.ChinesOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVin(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setShipmentStatus(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPurchasedAt(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmountStatus(value);
      break;
    case 12:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setVehicleAmount(value);
      break;
    case 13:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setShipmentAmount(value);
      break;
    case 14:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    case 15:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setPaidAmount(value);
      break;
    case 16:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setPendingAmount(value);
      break;
    case 17:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setRevertedAmount(value);
      break;
    case 18:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setDebtedAmount(value);
      break;
    case 19:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setToBePaidAmount(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsArchive(value);
      break;
    case 23:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setStorageFeeAmount(value);
      break;
    case 24:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setStorageFeeAmount2(value);
      break;
    case 25:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setStorageFeeAmount3(value);
      break;
    case 26:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setStorageFeeAmount4(value);
      break;
    case 27:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setStorageFeeAmount5(value);
      break;
    case 28:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setTotalStorageFeeAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mycargo.projects.erp.api.v1.model.ChinesOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getCustomerName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVin();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getShipmentStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPurchasedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAmountStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getVehicleAmount();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getShipmentAmount();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getPaidAmount();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getPendingAmount();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getRevertedAmount();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getDebtedAmount();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getToBePaidAmount();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIsArchive();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getStorageFeeAmount();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getStorageFeeAmount2();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getStorageFeeAmount3();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getStorageFeeAmount4();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getStorageFeeAmount5();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getTotalStorageFeeAmount();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 id = 2;
 * @return {number}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string customer_name = 3;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getCustomerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setCustomerName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 5;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string client_name = 7;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string vin = 8;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getVin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setVin = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string shipment_status = 9;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getShipmentStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setShipmentStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp purchased_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getPurchasedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setPurchasedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearPurchasedAt = function() {
  return this.setPurchasedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasPurchasedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string amount_status = 11;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getAmountStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setAmountStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional Money vehicle_amount = 12;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getVehicleAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 12));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setVehicleAmount = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearVehicleAmount = function() {
  return this.setVehicleAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasVehicleAmount = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Money shipment_amount = 13;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getShipmentAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 13));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setShipmentAmount = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearShipmentAmount = function() {
  return this.setShipmentAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasShipmentAmount = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Money total_amount = 14;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getTotalAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 14));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional Money paid_amount = 15;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getPaidAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 15));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setPaidAmount = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearPaidAmount = function() {
  return this.setPaidAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasPaidAmount = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Money pending_amount = 16;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getPendingAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 16));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setPendingAmount = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearPendingAmount = function() {
  return this.setPendingAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasPendingAmount = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional Money reverted_amount = 17;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getRevertedAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 17));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setRevertedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearRevertedAmount = function() {
  return this.setRevertedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasRevertedAmount = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional Money debted_amount = 18;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getDebtedAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 18));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setDebtedAmount = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearDebtedAmount = function() {
  return this.setDebtedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasDebtedAmount = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional Money to_be_paid_amount = 19;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getToBePaidAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 19));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setToBePaidAmount = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearToBePaidAmount = function() {
  return this.setToBePaidAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasToBePaidAmount = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string status = 20;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string comment = 21;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional bool is_archive = 22;
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getIsArchive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setIsArchive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional Money storage_fee_amount = 23;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStorageFeeAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 23));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStorageFeeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearStorageFeeAmount = function() {
  return this.setStorageFeeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasStorageFeeAmount = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional Money storage_fee_amount2 = 24;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStorageFeeAmount2 = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 24));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStorageFeeAmount2 = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearStorageFeeAmount2 = function() {
  return this.setStorageFeeAmount2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasStorageFeeAmount2 = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional Money storage_fee_amount3 = 25;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStorageFeeAmount3 = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 25));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStorageFeeAmount3 = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearStorageFeeAmount3 = function() {
  return this.setStorageFeeAmount3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasStorageFeeAmount3 = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional Money storage_fee_amount4 = 26;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStorageFeeAmount4 = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 26));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStorageFeeAmount4 = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearStorageFeeAmount4 = function() {
  return this.setStorageFeeAmount4(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasStorageFeeAmount4 = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional Money storage_fee_amount5 = 27;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getStorageFeeAmount5 = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 27));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setStorageFeeAmount5 = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearStorageFeeAmount5 = function() {
  return this.setStorageFeeAmount5(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasStorageFeeAmount5 = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional Money total_storage_fee_amount = 28;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.getTotalStorageFeeAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 28));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.setTotalStorageFeeAmount = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrder} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.clearTotalStorageFeeAmount = function() {
  return this.setTotalStorageFeeAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrder.prototype.hasTotalStorageFeeAmount = function() {
  return jspb.Message.getField(this, 28) != null;
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.toObject = function(opt_includeInstance) {
  return proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    chinesOrderName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    paymentTypeName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, ""),
    amount: (f = msg.getAmount()) && projects_erp_service_api_v1_model_money_pb.Money.toObject(includeInstance, f),
    comment: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment;
  return proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChinesOrderName(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentTypeName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = new projects_erp_service_api_v1_model_money_pb.Money;
      reader.readMessage(value,projects_erp_service_api_v1_model_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getChinesOrderName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPaymentTypeName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      projects_erp_service_api_v1_model_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 id = 2;
 * @return {number}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string chines_order_name = 3;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getChinesOrderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setChinesOrderName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string payment_type_name = 5;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getPaymentTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setPaymentTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Money amount = 7;
 * @return {?proto.mycargo.projects.erp.api.v1.model.Money}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getAmount = function() {
  return /** @type{?proto.mycargo.projects.erp.api.v1.model.Money} */ (
    jspb.Message.getWrapperField(this, projects_erp_service_api_v1_model_money_pb.Money, 7));
};


/**
 * @param {?proto.mycargo.projects.erp.api.v1.model.Money|undefined} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
*/
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string comment = 8;
 * @return {string}
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment} returns this
 */
proto.mycargo.projects.erp.api.v1.model.ChinesOrderPayment.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


goog.object.extend(exports, proto.mycargo.projects.erp.api.v1.model);
